<template>
  <div class="c-flex-c1 background darken-1" style="height: 100%;overflow: hidden;">

    <v-snackbar
    v-model="snackbarLoading"
    :timeout="0"
    top
    > 
      <div class="c-flex-c1 justify-center align-center">
        <div class="caption">
        LOADING
        </div>
        <v-progress-linear :indeterminate="true" class="mt-1 mb-1" color="green"></v-progress-linear>
      </div>
    </v-snackbar>

    <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
    <div>
      <v-container pa-0 pb-4 style="position: relative;">
        <!-- PC TOOLBAR -->
        <div v-if="!$vuetify.breakpoint.xs" class="pl-4 pr-4 pt-4">

          <v-breadcrumbs>
            <v-breadcrumbs-item to="/dashboard/">
              Home
            </v-breadcrumbs-item>
            <v-breadcrumbs-item disabled>
              Trace
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-layout align-center>
            <div class="headline font-weight-medium">
              Trace:
            </div>
            &nbsp;&nbsp;
            <v-icon color="text" small>mdi-qrcode-scan</v-icon>
            <span class="ml-1 title">
              {{ archiveItem.id }}
            </span>
          </v-layout>

        </div>

        <!-- MOBILE toolbar -->
        <div v-if="$vuetify.breakpoint.xs" class="toolbar-mobile">
          <v-layout align-center>
            <v-btn icon @click="drawer = !drawer">
              <v-icon>menu</v-icon>
            </v-btn>
            <v-flex class="text-ellipsed text-sans font-weight-bold">
              Trace
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </div>
    <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->

    <!-- MAIN CONTENT -->
    <div style="overflow: auto;">
      <v-container>
        
        <v-card outlined class="pa-2 mb-4">
          <timeline :archive_id="id"></timeline>
        </v-card>
        
        
        <v-layout wrap>
          <v-flex xs12 sm6 pa-1>
            <div class="c-card elevation-2">
              <v-layout align-center class="crx-toolbar subheading pa-2 pl-4 text-xs-center">
                Info
              </v-layout>

              <v-layout align-center pa-2>
                <div class="text-xs-center">
                  <img class="c-align-self-start" src="@/assets/img/illustrations/cream.png" alt="cardboard box" width="150px">
                  <div class="title">
                    <c-metric-selector
                    :inventoryItemID="archiveItem.inventory_item_id" 
                    :realValue="currentStock"
                    :key="archiveItem.id"
                    labelMode
                    alwaysScale
                    ></c-metric-selector>
                  </div>
                  <div class="caption">
                    in stock
                  </div>
                </div>
                
                <div class="ml-2">
                  <!-- a -->
                  <div class="title mb-2">
                    <router-link
                    class="rlink-hover blue--text"
                    style="text-decoration: none;display:inline-flex;align-items: center;"
                    :to="{ path: '/inventory/inventory-definition/view/' + definition.id}" @click.native.stop>
                      <span class="ml-1">{{ definition.name }}</span>
                    </router-link>
                  </div>
                  <v-layout align-center v-if="itemWasDelivered">
                    <v-avatar size="26" class="mr-2">
                      <v-icon color="text">mdi-account</v-icon>
                    </v-avatar>
                    <span class="font-weight-medium">
                      Supplier:
                    </span>
                    &nbsp;
                    <span v-if="supplier.name">
                      {{ supplier.name }}
                    </span>
                    <span v-else class="grey--text caption">
                      (not set)
                    </span>
                  </v-layout>
                  <v-layout align-center class="">
                    <v-avatar size="26" class="mr-2">
                      <v-icon color="text">mdi-barcode</v-icon>
                    </v-avatar>
                    <span class="font-weight-medium">
                      Batch number:
                    </span>
                    &nbsp;
                    <span v-if="archiveItem.batch_number">
                      {{ archiveItem.batch_number }}
                    </span>
                    <span v-else class="grey--text caption">
                      (not set)
                    </span>
                  </v-layout>
                  <v-layout align-center>
                    <v-avatar size="26" class="mr-2">
                      <v-icon color="text">mdi-calendar</v-icon>
                    </v-avatar>
                    <span class="font-weight-medium">
                      Expiry date:
                    </span>
                    &nbsp;
                    <span v-if="expiryFormatted">
                      {{ expiryRelative }}, {{ expiryFormatted }}
                    </span>
                    <span v-else class="grey--text caption">
                      (not set)
                    </span>
                  </v-layout>
                  <v-layout align-center>
                    <v-avatar size="26" class="mr-2">
                      <v-icon color="text">mdi-label</v-icon>
                    </v-avatar>
                    <span class="font-weight-medium">
                      Internal code:
                    </span>
                    &nbsp;
                    <span v-if="archiveItem.internal_code"
                    class="">
                      {{ archiveItem.internal_code }}
                    </span>
                    <span 
                    v-else-if="(!archiveItem.internal_code && archiveItem.supplier_id)"
                    class="color1--text rlink-hover"
                    flat
                    @click="newInternalCode">
                      &nbsp;Create code
                    </span>
                    <span v-else-if="!archiveItem.supplier_id" class="grey--text caption">
                      (not set, supplier info not entered)
                    </span>
                  </v-layout>
                  <!-- b -->
                </div>
              </v-layout>
            </div>
          </v-flex>
          <v-flex xs12 sm6 pa-1>
            <inventory-card :archiveItem="archiveItem"></inventory-card>
          </v-flex>
        </v-layout>

        <div class="c-card elevation-2 mt-2">
          <v-layout class="pa-2 pl-4 crx-toolbar subheading align-center">
            Timeline
          </v-layout>
          <v-timeline
          align-top
          dense
          >
            <v-timeline-item
            large
            color="transparent"
            fill-dot
            >
             <template v-slot:icon>
                <v-avatar v-if="itemWasDelivered">
                  <v-icon large color="green">mdi-truck-fast</v-icon>
                </v-avatar>
                <v-avatar v-else-if="itemWasProduced">
                  <img class="header-img pa-1" src="@/assets/img/illustrations/production.png" alt="cardboard box" width="120px">
                </v-avatar>
              </template>
              <v-layout pt-3>
                <v-flex xs3>
                  <strong>{{ arrivalRelative }}</strong>
                  <div class="caption">{{ arrivalFormatted }}</div>
                </v-flex>
                <v-flex xs9>
                  <template v-if="itemWasDelivered">
                    <strong>Item delivered</strong>
                    <div>
                      <router-link
                      class="caption rlink-hover"
                      style="text-decoration: none;"
                      :to="{ path: '/delivery/' + archiveItem.delivery_id}" @click.native.stop>
                        Delivery {{ archiveItem.delivery_id }}
                      </router-link>
                    </div>
                  </template>
                  <template v-else-if="itemWasProduced">
                    <strong>Item produced</strong>
                    <div>
                      <router-link
                      class="caption rlink-hover"
                      style="text-decoration: none;"
                      :to="{ path: '/production/' + archiveItem.production_id}" @click.native.stop>
                        Production {{ archiveItem.production_id }}
                      </router-link>
                    </div>
                  </template>
                  <span v-else>
                    Origin not set
                  </span>
                </v-flex>
              </v-layout>
            </v-timeline-item>
            <v-timeline-item
            color="green"
            small
            >
              <v-layout pt-3>
                <v-flex xs3>
                  <strong>...</strong>
                </v-flex>
                <v-flex xs9>
                  ...
                </v-flex>
              </v-layout>
            </v-timeline-item>

          </v-timeline>

        </div>

        <v-layout mt-4>
          <v-flex xs6 pa-1>
            <sales-card :id="id" :inventoryItemID="archiveItem.inventory_item_id"></sales-card>
          </v-flex>
          <v-flex xs6 pa-1>
            <production-card :id="id" :inventoryItemID="archiveItem.inventory_item_id"></production-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <!-- DIALOGS -->
    <internal-code-dialog ref="internalCodeDialog" @onUpdate="reload"></internal-code-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import InventoryCard from './components/inventory/card'
import SalesCard from './components/sales/sales-card'
import ProductionCard from './components/production/production-card'
import InternalCodeDialog from '../internal-codes/InternalCodeDialog'
import Timeline from '@/components/nav/tracer/views/timeline/Main'

export default {
  props: ['id'],
  components: {
    InventoryCard,
    SalesCard,
    ProductionCard,
    InternalCodeDialog,
    Timeline
  },
  data () {
    return {
      archiveItem: {},
      snackbarLoading: true
    }
  },
  computed: {
    definition () {
      return this.$store.state.db.inventoryDefinitions.definitions[this.archiveItem.inventory_item_id] || {}
    },
    supplier () {
      return this.$store.state.db.suppliers.suppliers[this.archiveItem.supplier_id] || {}
    },
    currentStockItems () {
      return Object.values(this.$store.state.db.inventory.inventory).filter(item => item.archive_id === parseInt(this.id))
    },
    currentStock () {
      return this.currentStockItems.reduce((a, i) => {
        return a += i.quantity
      }, 0)
    },
    itemWasDelivered () {
      return typeof this.archiveItem.delivery_id === 'number'
    },
    itemWasProduced () {
      return typeof this.archiveItem.production_id === 'number'
    },
    expiryFormatted () {
      if (this.$moment.utc(this.archiveItem.expiry_date).isValid()) {
        return this.$moment(this.archiveItem.expiry_date).format('ddd D MMM YYYY')
      }
      return ''
    },
    expiryRelative () {
      if (this.$moment.utc(this.archiveItem.expiry_date).isValid()) {
        return this.$moment.utc(this.archiveItem.expiry_date).fromNow()
      }
      return ''
    },
    arrivalFormatted () {
      if (this.$moment.utc(this.archiveItem.date_of_entry).isValid()) {
        return this.$moment(this.archiveItem.date_of_entry).format('ddd D MMM YYYY')
      }
      return ''
    },
    arrivalRelative () {
      if (this.$moment.utc(this.archiveItem.date_of_entry).isValid()) {
        return this.$moment.utc(this.archiveItem.date_of_entry).fromNow()
      }
      return ''
    },
    drawer: {
      get () {
        return this.$store.state.navMain
      },
      set (val) {
        this.$store.commit('openNavMain', val)
      }
    }
  },
  methods: {
    reload () {
      axios.all([
        this.$axios.get('/inventory-archive/' + this.id)
      ])
      .then(axios.spread((archiveItem) => {
        this.archiveItem = archiveItem.data
      }))
      .catch(error => this.$root.$errorSnackbar(error))
      .then(() => this.snackbarLoading = false)
    },
    newInternalCode () {
      var presets = {
        supplier: this.archiveItem.supplier_id,
        inventory_item_id: this.archiveItem.inventory_item_id
      }
      this.$refs.internalCodeDialog.new(presets)
    }
  },
  created () {
    this.reload()
  }
}
</script>

<style scoped lang="scss">
</style>

